import ToggleButton from "../fields/ToggleButton";

interface StepHabitatProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = ["Maison", "Appartement", "Autres"];

export default function StepHabitat({ value, onChange }: StepHabitatProps) {
  return (
    <fieldset style={{ border: "none" }}>
      <legend
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 12,
          display: "block",
          width: "100%",
        }}
      >
        Quel est votre type d&apos;habitat ?
      </legend>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
        }}
      >
        {OPTIONS.map((opt) => (
          <ToggleButton
            key={opt}
            label={opt}
            value={opt}
            active={value === opt}
            onClick={onChange}
            type="radio"
          />
        ))}
      </div>
    </fieldset>
  );
}
